// CompletedSession.js
import React, { useState } from "react";
import SessionCard from "./SessionCard";
import FeedbackModal from "./FeedbackModal"; // Import the FeedbackModal component

const CompletedSession = () => {
  const completedSessions = [
    // {
    //   date: "25 Aug 2023, 09:00 PM",
    //   profileImage: "https://cdn-icons-png.flaticon.com/512/3135/3135715.png",
    //   name: "Aman Kumar Mahto",
    //   topic: "Web Development",
    //   description:
    //     "Every utility class in Tailwind can be applied conditionally at different breakpoints, which makes it a piece of cake to build complex responsive interfaces without ever leaving your HTML.",
    // },
    // {
    //   date: "25 Aug 2023, 09:00 PM",
    //   profileImage: "https://cdn-icons-png.flaticon.com/512/3135/3135715.png",
    //   name: "John Doe",
    //   topic: "Web Development",
    //   description:
    //     "Every utility class in Tailwind can be applied conditionally at different breakpoints, which makes it a piece of cake to build complex responsive interfaces without ever leaving your HTML.",
    // },
    // Add more completed sessions here...
  ];

  const [showFeedbackModal, setShowFeedbackModal] = useState(false);
  const [selectedSession, setSelectedSession] = useState(null);

  const handleFeedbackClick = (name) => {
    setSelectedSession(name);
    setShowFeedbackModal(true);
  };

  const handleCloseFeedbackModal = () => {
    setShowFeedbackModal(false);
  };

  const handleSubmitFeedback = (feedback) => {
    // Handle feedback submission here
    alert(`Feedback submitted for ${selectedSession}: ${feedback}`);
    console.log(`Feedback submitted for ${selectedSession}: ${feedback}`);
    setShowFeedbackModal(false);
  };

  return (
    <div>
      {completedSessions.length === 0 ? (
        <div className="my-4 bg-blue-200 p-5 rounded-md">
          <p>Your completed sessions will be shown here.</p>
        </div>
      ) : (
        completedSessions.map((session, index) => (
          <div key={index} className="my-4 bg-blue-200 rounded-md">
            <SessionCard sessionData={session} />
            <button
              className="bg-blue-500 text-white ml-5 mb-5 px-3 py-2 rounded-lg"
              onClick={() => handleFeedbackClick(session.name)}
            >
              Feedback
            </button>
          </div>
        ))
      )}

      {showFeedbackModal && (
        <FeedbackModal
          sessionName={selectedSession}
          onClose={handleCloseFeedbackModal}
          onSubmit={handleSubmitFeedback}
        />
      )}
    </div>
  );
};

export default CompletedSession;
